export const esignRecord ={
  "urge": "",
  "copyLink": "",
  "check": "",
  "urgeContent": "",
  "sign": ""
}